module.exports = __webpack_public_path__ + "img/hr-burner-inserter-platform.6799d9da.png";